import { render } from "./Patient_Variants.vue?vue&type=template&id=0badf89e"
import script from "./Patient_Variants.vue?vue&type=script&lang=js"
export * from "./Patient_Variants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__